import { showCartErrorMessage } from 'features/cart/desktop';
import { updateUtagData, utagLinkCart } from 'features/tealium/';
import { getCartDataFromUtag, trackCartUpdates } from 'features/monetate';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import { cart, cartModel } from '../config';
import RemovePromoCodeLinkTemplate from '../templates/RemovePromoCodeLinkTemplate';
import CartBaseItemView from '../../baseViews/ItemView';
import { DeleteCartPromoCode } from '../../api';

const trackCartEvents = utagLinkCart();

const RemovePromoCodeLink = CartBaseItemView.extend({
	tagName: 'button',
	attributes: {
		type: 'button',
		'aria-label': 'Remove Coupon Code'
	},
	className: 'removePromoCode anchorLink',
	JSXTemplate: RemovePromoCodeLinkTemplate,
	events: {
		click: 'removePromoCode'
	},
	initialize () {

		this.listenTo(this.model, 'change', this.render, this);

	},
	onDomRefresh () {

		if (this.model.get('SelectedPromoCode')) {

			this.$el.parent().removeClass('hidden');

		} else {

			this.$el.parent().addClass('hidden');

		}

	},
	removePromoCode (e) {

		e.preventDefault();

		const request = DeleteCartPromoCode().then((response) => {

			if (response.operationSuccess) {

				const removedPromoCode = this.model.get('SelectedPromoCode');

				updateUtagData(response.GlobalCartResponseModel.TealiumTagData);
				// Monetate AJAX update (retrack)
				trackCartUpdates(getCartDataFromUtag());

				cartModel.update(response);
				if (removedPromoCode) {

					// fire GA event for remove promo code
					trackCartEvents({ eventAction: 'remove-Coupon', eventLabel: removedPromoCode });

					if (
						[ 'none', 'consumer', 'professional', 'employee' ].includes(
							window.utag_data.user_type.toLowerCase()
						)
					) {

						setGenericEvent({
							event_name: 'cart_promo_remove',
							promocode: 'promo code customer removed successfully',
							promocode_value: removedPromoCode
						});

					}

				}

			} else {

				showCartErrorMessage({ response });

			}

		});
		$(cart).trigger('indicateLoad', request);

	}
});

export default RemovePromoCodeLink;
